import { AdminState } from './types'

export const initialState: AdminState = {
  pendingOrdersCount: null,
  isLoadingPendingCount: false,
  pendingCountError: null,
  
  dashboardStats: null,
  isLoadingDashboard: false,
  dashboardError: null
}

